import React from "react";
import {
  List,
  Datagrid,
  TextField,
  EditButton,
  DeleteButton,
  DateField,
} from "react-admin";

const LocationsList: React.FC = () => (
  <List>
    <Datagrid>
      <TextField source="location" label="Location" />
      <DateField
        source="created_at"
        label="Created At"
        options={{ year: "numeric", month: "long", day: "2-digit" }}
      />
      <EditButton />
      <DeleteButton />
    </Datagrid>
  </List>
);

export default LocationsList;
